import { version } from '~/package.json'

export default defineAppConfig({
  appVersion: version,
  siteName: 'KFV Portal Trainer',
  // apiBaseUrl: 'https://my.1tool.com/suite/api/',
  // (Falls neue API Url nicht funktioniert):
  apiBaseUrl: 'https://develop-api.1tool.cloud/suite/api/',
  apiBaseUrlV2: 'https://my.1tool.com/suite/api/v2/',
  tenantId: '3ea079e3-7de4-47de-ab8f-cb174a7ec9a5',
  routing: {
    startPage: 'projects'
  },
  vendor: {
    vuelidate: {
      $lazy: true,
      $autoDirty: false
    },
    marked: { headerIds: false, mangle: false }
  },
  optimizeDeps: {
    include: ['esm-dep' > 'cjs-dep']
  },
  ui: {
    primary: 'customPrimary'
  }
})
